import { isEmpty } from 'lodash';
import { PERMISSION } from 'static/Permission';

export const enableMakeActiveProduct = (product) => {
  if (isEmpty(product)) return false;

  const { isOwner, isPaid, isPrivateLabel, isIxOneCaptured } = product;

  return isOwner && !isPaid && !isPrivateLabel && !isIxOneCaptured;
};

export const disableMakeActiveProduct = ({
  isOwner,
  isPaid,
  isPrivateLabel,
  isIxOneCaptured,
  status,
} = {}) => {
  return (
    !isOwner ||
    isPaid ||
    isPrivateLabel ||
    isIxOneCaptured ||
    status?.toLowerCase() === 'active'
  );
};

export const enableStatusSelectionInCreateMode = ({
  valueOption,
  isPrivateLabel,
  userInfo,
}) => {
  const isActiveValueOption = valueOption?.toLowerCase() === 'active';

  if (isActiveValueOption) {
    const permissions = userInfo?.permissions || [];

    if (isPrivateLabel) {
      return (
        permissions.includes(PERMISSION.CREATE_PRODUCT) &&
        permissions.includes(PERMISSION.PAY_WITH_MEMBER_CREDIT_CARD)
      );
    }

    return permissions.includes(PERMISSION.PAY_WITH_MEMBER_CREDIT_CARD);
  }

  return true;
};

export const disableStatusSelectionInEditModeInCreateMode = ({
  valueOption,
  isPrivateLabel,
  userInfo,
}) => {
  return !enableStatusSelectionInCreateMode({
    valueOption,
    isPrivateLabel,
    userInfo,
  });
};

export const disableStatusSelectionInEditMode = ({
  valueOption,
  isOwner,
  isPaid,
  isPrivateLabel,
  isIxOneCaptured,
}) => {
  const isActiveValueOption = valueOption?.toLowerCase() === 'active';

  if (isOwner) {
    return (
      isActiveValueOption &&
      enableMakeActiveProduct({
        isOwner,
        isPaid,
        isPrivateLabel,
        isIxOneCaptured,
      })
    );
  }
  return isActiveValueOption && !isOwner;
};
